import React from "react";
import "../ContactSales.scss";
import man from "../../images/testimonial.svg";
import icon from "../../images/testimonialIcon.svg";
import Footer from "./Footer.js";
const ContactSalesComponent = () => {
  return (
    <div id="contact" className="contactsalesPage">
      <div className="testimonials">
        <div className="testimonial">
          <div className="leftTestimonialS">
            <img className="imageT"  src={man} alt="testimonial" />
          </div>
          <div className="rightTestimonialS">
            <h2 className="testimonialTitile">
              Christophe Bourand, ChrisWebMarketing
            </h2>
            <h3 className="testimonialParagraph">
              Juggling with all my clients and making sure everything was done
              correctly took me a lot of energy. Not did Snikpic enabled me to
              tremendously release that extra useless work, but I quickly found
              myself able to take on much more clients than I originally could
            </h3>
            <img src={icon} alt="Icon" />
          </div>
        </div>
        <div id="form" className="form">
          <h1  >apply to our<span className="orangeTitle"> closed beta.</span> </h1>
          <div className="forms">
            <div className="leftForm">
              <p className="formTitile" >Name</p>
              <input
                className="contactForm"
                placeholder="Let’s not be strangers"
                type="text"
              />
              <p className="formTitile" >Phone Number</p>
              <input
                className="contactForm"
                placeholder="470000000"
                type="text"
              />
            </div>
            <div className="leftForm">
              <p className="formTitile" >Website</p>
              <input
                className="contactForm"
                placeholder="Put the URL right there"
                type="text"
              />
              <p className="formTitile" >Email Address</p>
              <input
                className="contactForm"
                placeholder="That’s right, we need your email"
                type="text"
              />
            </div>
          </div>
          <a href="#" className="signUpButton">
            Send
          </a>
          
        </div>
        
      </div>
      <Footer />
    </div>
  );
};

export default ContactSalesComponent;
